'use strict';

module.exports = 'data-reactid';


//////////////////
// WEBPACK FOOTER
// ./~/react-three-renderer/lib/utils/idPropertyName.js
// module id = 60
// module chunks = 110308036455227 195351340454287